<template>
  <div
    data-component-group="auth-form"
    data-component="forgot-pass"
    :class="generateTestClass('form')"
  >
    <Form
      :title="$t('views_reset_second_title')"
      :subtitle="$t('views_reset_subtitle')"
      @submit="submit"
    >
      <v-text-field
        v-model="email"
        :class="generateTestClass('form-field-email')"
        prepend-inner-icon="mail"
        :label="$t('email_placeholder')"
        required
        type="text"
        :autofocus="true"
        :error-messages="emailErrors"
        @blur="v$.email.$touch()"
      />

      <div class="form-actions">
        <router-link
          :to="{ name: 'login' }"
          class="go-to-reset-pass"
        >
          {{ $t('back_to_login') }}
        </router-link>
        <v-btn
          color="primary"
          class="trigger"
          :class="generateTestClass('form-btn-submit')"
          :loading="isLoading"
          :disabled="isDisabled"
          type="submit"
        >
          <v-icon> email </v-icon>
          {{ $t('components_forms_reset_submit') }}
        </v-btn>
      </div>
    </Form>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core'
  import { required, email } from '@vuelidate/validators';
  import testClassMixin from '../../../mixins/testClass';
  import recaptchaMixin from '../../../mixins/recaptcha';
  import Form from '../Form';

  export default {
    components: {
      Form,
    },
    setup () {
      return { v$: useVuelidate() }
    },
    mixins: [testClassMixin, recaptchaMixin],
    validations: {
      email: {
        required,
        email,
      },
    },
    props: {
      hasRecaptcha: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      email: '',
      isLoading: false,
      isSubmitted: false,
    }),
    computed: {
      emailErrors() {
        return this.v$.email.$errors.map(error => {
          if (error.$validator === 'required') {
            return this.$t('email_required');
          }
          if (error.$validator === 'email') {
            return this.$t('email_valid');
          }
          return error.$message;
        });
      },
      isDisabled() {
        return this.email === '';
      },
    },
    created() {
      this.$store.watch(
        () => {
          const hasErrors = this.$store.getters['alerts/error'].length > 0;

          if (this.isSubmitted && hasErrors) {
            this.isSubmitted = false;
            this.isLoading = false;
          }
        },
        () => {},
      );
    },
    methods: {
      async submit() {
        if (this.isLoading) return;

        this.v$.$touch();

        if (!this.canSubmitRequest() || this.v$.pending || this.v$.invalid) {
          return false;
        }

        let token = '';
        if (this.hasRecaptcha) {
          token = await this.getRecaptchaToken('forgot_password');

          if (token === null) {
            return false;
          }
        }
        return this.sendPassResetRequest(token);
      },
      clear() {
        this.v$.$reset();
        this.email = '';
        this.isSubmitted = false;
      },
      canSubmitRequest() {
        return this.email !== '';
      },
      sendPassResetRequest(token = '') {
        this.isLoading = true;
        this.isSubmitted = true;
        return this.$store
          .dispatch('auth/sendPassResetRequest', { email: this.email, recaptcha: token })
          .catch(() => {
            this.isLoading = false;
            this.isSubmitted = false;
          });
      },
    },
  };
</script>
